module.exports = __webpack_public_path__ + "img/item-1.0080d9d.png";